import { translateFn } from '../../../../../../../../utils/translator.helper';
import { html } from 'lit';
import { query } from 'lit/decorators.js';
import { WEB_COMPONENT_GZ_DATA_TABLE } from '../../../../../../../../webcomponents.constants';
import { GzDataTableWebComponent } from '../../../../../../../../ui/gzDataTable';
import { DataTableStrings, IDataTableColumn } from '../../../../../../../../ui/gzDataTable/types';
import { GzPolicyUiSettingsBaseGrid } from '../../base';
import { getDataTableDefaultStrings } from '../../../../../../../../ui/gzDataTable/types/strings';

export abstract class GzPolicyUiSettingsTableWebComponent<
  GridItem,
  GridItemFormValue
> extends GzPolicyUiSettingsBaseGrid<IDataTableColumn, GridItem, GridItemFormValue> {
  // grid inline row actions
  protected hasReorderRowAction = true;

  // translations
  protected translations: DataTableStrings = {
    ...getDataTableDefaultStrings(),
    requiredFieldMessage: translateFn('Required field'),
    extraValidationToastMessage: translateFn('The entry already exists.'),
    disabledEditTooltip: translateFn('Validation failed due to errors.'),
    editRowTooltip: translateFn('Edit'),
    deleteRowTooltip: translateFn('Delete'),
    validateEditTooltip: translateFn('Save#preserve state'),
    cancelEditTooltip: translateFn('Cancel'),
  };

  // selectors
  @query(WEB_COMPONENT_GZ_DATA_TABLE)
  protected gridComponent: GzDataTableWebComponent<GridItem>;

  public getFormValue(): GridItem[] {
    return this.gridComponent?.getFormValue();
  }

  protected computeGridValues() {
    this.gridComponent.items = this.initialGridItems;
    this.onGridItemsChange();
  }

  protected renderGrid() {
    return html`<gz-data-table
      .columns="${this.columns}"
      .strings="${this.translations}"
      .allowRowReordering="${this.hasReorderRowAction}"
      .allowRowDeletion="${this.hasDeleteRowAction}"
      .allowRowEditing="${this.hasEditRowAction}"
      .extraValidator="${(newItem: GridItem, oldItem: GridItem, rowIndex: number, currentItems: GridItem[]) =>
        this.validateGridItemBeforeEdit(oldItem, newItem).valid}"
      @empty-state-footer-button-clicked="${this.focusFirstInput.bind(this)}"
      @row-deleted="${this.onDeleteGridItem.bind(this)}"
      @row-editing-started="${this.onEditRowEnabled.bind(this)}"
      @row-editing-cancelled="${this.onEditRowCancel.bind(this)}"
      @row-edited="${this.onEditRowSave.bind(this)}"
    >
    </gz-data-table> `;
  }

  protected focusFirstInput() {
    this.gridItemForm.focusFirstInput();
  }

  protected addGridItem(item: GridItem, position?: number) {
    if (position !== undefined) {
      this.gridComponent.addItemToIndex(item, position - 1);
    } else {
      this.gridComponent.addItem(item);
    }
    this.emitChangeEvent();
  }

  protected onDeleteGridItem(event: CustomEvent) {
    this.emitChangeEvent();
  }

  protected onEditRowSave(event: CustomEvent) {
    this.emitChangeEvent();
  }

  protected emitChangeEvent() {
    this.onGridItemsChange();
    this.dispatchEvent(new CustomEvent('change', { bubbles: true, composed: true }));
  }
}
